module.exports = "/_next/static/images/pt_icon-50b36c5aee6db32367e50ed4478b1c1c.svg";